import moment from "moment";

const version = process.env.VUE_APP_VERSION.split("+");

export default {
  app_version: version[0] || '3.0.0',
  app_build_date: version[1] || moment().format('YYYYMMDD'),
  ruta_api: process.env.VUE_APP_API_URL || "http://127.0.0.1:8000/api/",
  ruta_image: process.env.VUE_APP_API_URL_IMAGE || "http://127.0.0.1:8000/",
  support_email: process.env.VUE_APP_SUPPORT_EMAIL || "soporte@tiresoft.pe",
  helpdesk_url:
    process.env.VUE_APP_HELPDESK_URL || "https://helpdesk.tiresoft.pe/",

  _objeto_es_vacio: function (obj) {
    return Object.keys(obj).length == 0;
  },

  _json_to_query_string: function (json) {
    json = Object.keys(json).map((item) => {
      return item + "=" + json[item] || "";
    });
    return json.join("&");
  },

  _fecha_valida(fecha) {
    return (fecha = moment(fecha, "YYYY-MM-DD", true).isValid());
  },

  _validar_fecha(fecha) {
    let fechaactual = moment(new Date());
    fecha = moment(fecha, "YYYY-MM-DD");

    if (fechaactual >= fecha) {
      return fecha.format("YYYY-MM-DD");
    } else {
      return fechaactual.format("YYYY-MM-DD");
    }
  },
  _autorizacion_usuario(permisos, permiso, acciones) {
    // Inicializa la autorización
    let autorizacion = false;

    // Verifica si la acción está presente en los permisos del usuario
    for (let accionKey in permisos[permiso]) {
      // Comprueba si alguna acción en el array 'acciones' está en los permisos
      if (acciones.some((accion) => permisos[permiso][accionKey] === accion)) {
        autorizacion = true;
        break; // Sale del bucle si encuentra al menos una coincidencia
      }
    }

    return autorizacion;
  },

  _arrayValoresUnicos: function (
    array_general,
    descripcion,
    limite = true,
    grupo = "",
  ) {
    let cantidad = 10;
    let total = 0;
    let totalgeneral = 0;
    let array_temporal = [];

    array_general.forEach((element, i) => {
      if (i == 0) {
        element.name = element[descripcion];
        array_temporal.push({
          ...element,
        });
        totalgeneral += element["cantidad"];
      } else {
        //buscar si el elemento existe, si existe sumar de lo contrario ingresar al array
        let dato = null;
        if (grupo != "") {
          dato = array_temporal.find(
            (el) =>
              el[descripcion] == element[descripcion] &&
              el[grupo] == element[grupo],
          );
        } else {
          dato = array_temporal.find(
            (el) => el[descripcion] == element[descripcion],
          );
        }

        if (dato) {
          dato.cantidad += element.cantidad;
          totalgeneral += element.cantidad;
        } else {
          element.name = element[descripcion];
          totalgeneral += element["cantidad"];
          array_temporal.forEach((value) => {
            if (value.name == element.name) {
              element.name = element.name + " ";
            }
          });

          array_temporal.push({
            ...element,
          });
        }
      }
    });
    //ordenar de mayor a menor cantidad
    array_temporal.sort((a, b) => b.cantidad - a.cantidad);

    let array = [];
    if (limite == false) {
      cantidad = array_general.length;
    }

    for (let index = 0; index < cantidad; index++) {
      if (array_temporal[index]) {
        array.push(array_temporal[index]);
        total += parseInt(array_temporal[index]["cantidad"]);
      }
    }

    array_temporal.forEach((element) => {
      element.porcentaje = ((element.cantidad / totalgeneral) * 100).toFixed(2);
    });

    let datos = {
      total: total,
      array: array,
    };

    return datos;
  },

  async _exportar_a_excel(ruta = "", method = "GET", data) {
    const { axios2: axios } = await import("@/interceptor/useApi");
    let url = this.ruta_api + ruta;
    await axios({
      url: url,
      method: method,
      data: data,
      responseType: "blob",
    })
      .then(async (response) => {
        var nombre_archivo = response.headers["nombre-archivo"];
        if (response.data.type == "text/html") {
          // no es excel, probablemente es json con un mensaje de error
          const res = JSON.parse(await response.data.text());
          if (!res.exito) {
            alert(res.mensaje || "Sucedió un error, intentelo nuevamente");
          }
        } else {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", nombre_archivo);
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        this.loader = false;
        this.errorMessage = error.response.data;
        console.error("error!", error);
      });
  },

  verificarDuplicados: function (list, item) {
    let existe = false;
    list.forEach((element) => {
      if (element.text == item) {
        existe = true;
      }
    });
    return existe;
  },

  formatearFecha(fechaStr) {
    if (!fechaStr) return "-";
    let str = String(fechaStr).trim();

    // Si viene fecha y hora separadas por espacio o 'T'
    const partes = str.split(/[ T]/);
    let parteFecha = partes[0];

    const sep = parteFecha.includes("-") ? "-" : parteFecha.includes("/") ? "/" : null;
    if (sep) {
      const fPartes = parteFecha.split(sep);
      if (fPartes.length === 3) {
        if (fPartes[0].length === 4) {
          // YYYY-MM-DD -> DD-MM-YYYY
          return `${fPartes[2].padStart(2, "0")}-${fPartes[1].padStart(2, "0")}-${fPartes[0]}`;
        } else {
          // DD-MM-YYYY
          return `${fPartes[0].padStart(2, "0")}-${fPartes[1].padStart(2, "0")}-${fPartes[2]}`;
        }
      }
    }

    const m = moment(str);
    if (m.isValid()) {
      return m.format("DD-MM-YYYY");
    }

    return str;
  },

  formatearFechaHora(fechaStr) {
    if (!fechaStr) return "-";
    let str = String(fechaStr).trim();

    // Si viene en formato con fecha y hora separadas por espacio o 'T'
    const partes = str.split(/[ T]/);
    if (partes.length >= 2 && partes[1] && partes[1].trim() !== "") {
      let parteFecha = partes[0];
      let parteHora = partes[1].split(".")[0].replace("Z", "").trim();

      const sep = parteFecha.includes("-") ? "-" : parteFecha.includes("/") ? "/" : null;
      if (sep) {
        const fPartes = parteFecha.split(sep);
        if (fPartes.length === 3) {
          if (fPartes[0].length === 4) {
            // YYYY-MM-DD -> DD-MM-YYYY
            parteFecha = `${fPartes[2].padStart(2, "0")}-${fPartes[1].padStart(2, "0")}-${fPartes[0]}`;
          } else {
            // DD-MM-YYYY
            parteFecha = `${fPartes[0].padStart(2, "0")}-${fPartes[1].padStart(2, "0")}-${fPartes[2]}`;
          }
        }
      }

      const hPartes = parteHora.split(":");
      if (hPartes.length === 2) {
        parteHora = `${hPartes[0].padStart(2, "0")}:${hPartes[1].padStart(2, "0")}:00`;
      } else if (hPartes.length >= 3) {
        parteHora = `${hPartes[0].padStart(2, "0")}:${hPartes[1].padStart(2, "0")}:${hPartes[2].padStart(2, "0")}`;
      }

      return `${parteHora} ${parteFecha}`;
    }

    // Si no contiene horas, validar y retornar únicamente dia-mes-año
    return this.formatearFecha(str);
  },
};
